import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPaginatedSurveyViewResultsRPC } from "./getPaginatedSurveyViewResultsRPC";

export class GetPaginatedSurveyViewResultsRPCClientImpl extends GetPaginatedSurveyViewResultsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPaginatedSurveyViewResultsRPC.Request): Promise<LeoRPCResult<GetPaginatedSurveyViewResultsRPC.Response, GetPaginatedSurveyViewResultsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/GetPaginatedSurveyViewResults",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPaginatedSurveyViewResultsRPC.ResponseDTO,
      GetPaginatedSurveyViewResultsRPC.Errors.ErrorsDTO,
      GetPaginatedSurveyViewResultsRPC.Response,
      GetPaginatedSurveyViewResultsRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/GetPaginatedSurveyViewResults",
      GetPaginatedSurveyViewResultsRPC.Response.fromDTO,
      GetPaginatedSurveyViewResultsRPC.Errors.fromDTO
    );
  }
}
